var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('iframe',{staticClass:"iframe_box",attrs:{"src":"/能链企服隐私政策2.4.html","frameborder":"0"}})])
}]

export { render, staticRenderFns }